import ContentPointsView from './content-points-view';
import QuestionTypesView from './question-types-view';
import ProficienciesView from './proficiencies-view';
import { ContentPoint } from './content-points.constants';

type Props = {
  contentPoints: ContentPoint[];
  questionTypes: string[];
  proficiencies: string[];
};

/**
 * Renders content-point metadata: content points, question types, and proficiencies.
 *
 * Displays ContentPointsView, QuestionTypesView, and ProficienciesView when the
 * corresponding arrays are non-empty. Each section is omitted when its data is empty.
 *
 * @param props - Component props
 * @param props.contentPoints - Array of content points to display
 * @param props.questionTypes - Array of question type labels
 * @param props.proficiencies - Array of proficiency labels (e.g. maths proficiencies)
 * @returns JSX element - Container with optional content points, question types, and proficiencies sections
 *
 * @example
 * ```tsx
 * <ContentPointsMetadataView
 *   contentPoints={outcome.contentPoints}
 *   questionTypes={outcome.questionTypes ?? []}
 *   proficiencies={outcome.proficiencies ?? []}
 * />
 * ```
 */
const ContentPointsMetadataView = ({
  contentPoints,
  questionTypes,
  proficiencies,
}: Props) => {
  return (
    <div>
      {/* Content Points */}
      {contentPoints && contentPoints.length > 0 && (
        <ContentPointsView contentPoints={contentPoints} />
      )}

      {/* Question Types */}
      {questionTypes && questionTypes.length > 0 && (
        <QuestionTypesView questionTypes={questionTypes} />
      )}

      {/* Maths Proficiencies */}
      {proficiencies && proficiencies.length > 0 && (
        <ProficienciesView proficiencies={proficiencies} />
      )}
    </div>
  );
};

export default ContentPointsMetadataView;
